import React, { Dispatch, SetStateAction } from "react";
import {
  CountryCode,
  countryCodeToCountries,
  countryCodeToCountry,
  sortedCountryCodes,
} from "./countries";
import usePhoneInput from "./usePhoneInput";

type PhoneNumberInputProps<T extends React.ElementType = "input"> = ReturnType<
  typeof usePhoneInput
> & {
  countryCodeInput?: {
    element?: T;
    props?: React.ComponentProps<T>;
    propMapper?: (
      props: React.ComponentProps<"input">
    ) => React.ComponentProps<T>;
  };
  localNumberInput?: {
    element?: T;
    props?: React.ComponentProps<T>;
    propMapper?: (
      props: React.ComponentProps<"input">
    ) => React.ComponentProps<T>;
  };
  flagPosition?: { top: number; left: number };
  setError?: Dispatch<SetStateAction<string | undefined>>;
};

export default function PhoneNumberInput<
  T extends React.ElementType = "input"
>({
  localNumberInput,
  countryCodeInput,
  flagPosition = { top: -10, left: 0 },
  countryFlag,
  countryCode,
  setCountryCode,
  localNumber,
  setLocalNumber,
}: PhoneNumberInputProps<T>) {
  const CountryCodeInput = countryCodeInput?.element ?? "input";
  const countryCodePropsMapper =
    countryCodeInput?.propMapper ?? ((props) => props);
  const LocalNumberInput = localNumberInput?.element ?? "input";
  const localNumberPropsMapper =
    localNumberInput?.propMapper ?? ((props) => props);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        position: "relative",
        width: "100%",
      }}
    >
      <span
        style={{
          position: "absolute",
          ...flagPosition,
        }}
      >
        <span style={{ position: "relative", fontSize: "x-large", top: "4px" }}>
          {countryFlag}
        </span>{" "}
        +
      </span>
      <CountryCodeInput
        {...countryCodePropsMapper({
          type: "text",
          list: "countries",
          maxLength: 3,
          value: countryCode,
          onChange: (e) => {
            const value = e.target.value.split(" ")[0];
            if (!Number.isNaN(Number(value)))
              setCountryCode(value.trim() as CountryCode);
          },
        })}
        {...countryCodeInput?.props}
      />
      <datalist id="countries">
        {sortedCountryCodes.map((code) => (
          <option key={code}>
            {`${code} ${countryCodeToCountry[code]}${
              countryCodeToCountries[code].length > 1
                ? ` +${countryCodeToCountries[code].length - 1} more`
                : ""
            }`}
          </option>
        ))}
      </datalist>
      <div style={{ position: "relative", width: "100%" }}>
        <LocalNumberInput
          {...localNumberPropsMapper({
            type: "tel",
            maxLength: 13,
            value: localNumber,
            onChange: (e) => setLocalNumber(e.target.value),
          })}
          {...localNumberInput?.props}
        />
      </div>
    </div>
  );
}
